import React from 'react';
import InputTypes from './InputTypes';

const Responses = ({ type, value, ...rest }) => {
  const Component = isNaN(type)
    ? InputTypes[type]
    : Object.values(InputTypes)[type];
  return Component
    ? <Component {...rest} value={value || ''} />
    : <h4>Question type({type}) is not supported</h4>;
};

export default Responses;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/Responses.js